<template>
  <div>
    <surveys-table
      surveyName="POEM"
      surveyCode="POEM"
      :permission="{
        createSurvey: permissions.CREATE_SURVEY_POEM,
        viewDetail: permissions.SEE_DETAIL_SURVEY_POEM,
      }"
    ></surveys-table>
  </div>
</template>

<script>
import SurveysTable from "../../../components/Forms/SurveysTable.vue";
import { permissions } from "../../../enum/applicationPermissions";

export default {
  components: {
    SurveysTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
